import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Table, Pagination, Col } from 'antd';
import 'ant-design-pro/dist/ant-design-pro.css';
import { GET_MONITORING_DATA } from '../../state/dashboard/types';
import { RESOURCE } from '../../config/constants/alerts';
import PropTypes from 'prop-types';

const DashboardTable = ({ getData, count, pagination }) => {

  const [totalDocs, setTotalDocs] = useState(1);

  useEffect(() => { getData({ limit: 10, page: 1 }); }, []);

  useEffect(() => {
    if (pagination && pagination.total) {
      setTotalDocs(pagination.total);
    }
  }, [pagination]);

  /**
   * Array of objects with table column information
   */
  const columns = [
    {
      title: 'Fecha',
      dataIndex: 'date',
    },
    {
      title: 'Ingreso diario a formulario',
      dataIndex: 'contract',
    },
    {
      title: 'Ingreso diario a vista de previsualizción',
      dataIndex: 'review',
    },
    {
      title: 'Ingreso diario a formulario de pago webpay',
      dataIndex: 'webpay',
    },
    {
      title: 'Contratos pagados',
      dataIndex: 'success',
    }
  ];

  const data = count[0] && count.map((document, index) => ({
    key: index,
    date: document.created_at && document.created_at.substring(0, 10),
    contract: document.contract,
    review: document.review,
    webpay: document.webpay,
    success: document.success,
  }));

  const PaginationTable = () => {
    const getMoreDocs = (page) => {
      getData({ limit: 10, page: page });
    };
    return (
      <Pagination
        defaultCurrent={pagination.currentPage}
        total={totalDocs}
        onChange={getMoreDocs}
        pageSize={10}
      />
    );
  };

  return (
    <>
      <div className="site-card-wrapper">
        <Table
          columns={columns}
          dataSource={data}
          scroll={{ x: 1300, y: 400 }}
          pagination={false}
        />
      </div>
      <Col xs={24} className="d-flex justify-content-end">
        <PaginationTable />
      </Col>
    </>
  );
};

DashboardTable.propTypes = {
  getData: PropTypes.func.isRequired,
  count: PropTypes.array.isRequired,
  pagination: PropTypes.object.isRequired,
};

const data = (state) => ({
  listIsLoaded: state.dashboard.listIsLoaded,
  count: state.dashboard.count,
  pagination: state.dashboard.pagination
});

const action = dispatch => ({
  getData: (params) => dispatch({ type: GET_MONITORING_DATA, payload: { params: params, resource: RESOURCE.GET_MONITORING_DATA } }),
});

export default connect(data, action)(DashboardTable);